import * as busyCounter from '../../../sharedmodules/action-creators/busy-counter';

import { createSuccessMessage } from '../../../sharedmodules/action-creators/alert-messages';
import { editNotification } from '../repositories/editNotification';
import { handleError } from '../../../sharedmodules/services/error-handlers';
import { readNotificationData } from './read-notification';
import { translate } from '../../../sharedmodules/services/translation-service';
import { updateModalVisibility } from '../../../sharedmodules/action-creators/modal';

export const editNotificationData = (getAccessToken,
    notification,
    isVisible) => async (dispatch) => {

    dispatch(busyCounter.increaseBusyCounter());
    try {

        const notificationData = await editNotification(getAccessToken, notification);
        if (notificationData.status === 200) {

            dispatch(createSuccessMessage(translate('NOTIFICATION_UPDATED_SUCCESSFULLY')));
            dispatch(readNotificationData(getAccessToken));

        }

    } catch (error) {

        handleError(error);

    } finally {

        setTimeout(() => {

            dispatch(updateModalVisibility(isVisible));
            dispatch(busyCounter.decreaseBusyCounter());

        }, 300);

    }

};
